import { Component } from '@angular/core';

@Component({
  selector: 'app-student-feedback-link',
  templateUrl: './student-feedback-link.component.html',
  styleUrls: ['./student-feedback-link.component.scss']
})
export class StudentFeedbackLinkComponent {

}
